import { useState } from "react";

import GenrateDocument from "../../GenrateDocument/GenrateDocument";
import DocumentRow from "../../DocumentRow/DocumentRow";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import InfoPanelWithoutKeyValue from "../../ClientDashboard/shared/InfoPanelWithoutKeyValue";
import { currencyFormat, formatDateForPanelDisplay } from "../../../Utils/helper";
import "../../common/RecordPanel.css";

const WageLossTab = ({ employmentData, onEdit }) => {
  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const [dropdownName, setDropdownName] = useState("");

  const handleGenrateDocument = (instanceId, dropDownName) => {
    setDropdownName(dropDownName);
    setInstanceIdForGenragteDoc(instanceId);
    setShowDocument(true);
  };

  const DefendantButtonsConfig = [
    {
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: handleGenrateDocument,
    },
  ];

  return (
    <>
      {employmentData.length > 0 ? (
        employmentData.map((employment) => {
          const { id, employment_contact, manager, supervisor, employer_name } = employment;
          const employmentTimeInfoData = [
            {
              label: "Time Missed",
              value: employment?.total_time_missed ? `${employment.total_time_missed} hrs` : "",
            },
            {
              label: "Hourly Rate",
              value: currencyFormat(employment?.rate_of_pay),
            },
            {
              label: "Sick Time Used",
              value: employment?.sick_time_used ? `${employment.sick_time_used} hrs` : "",
            },
            { label: "Disability Paid", value: currencyFormat(employment?.disability_paid) },
            {
              label: "Date Terminated",
              value: formatDateForPanelDisplay(employment?.date_terminated),
            },
            // { label: "\u00A0", value: "\u00A0" },
            // { label: "Total Wages Lost", value: "" },
          ];

          const employmentInfoData = [
            {
              isParty: true,
              value:
                `${employment?.disability_lien_contact?.first_name || ""} ${employment?.disability_lien_contact?.last_name || ""}`.trim(),
            },
            { label: "Account #", value: employment?.account_number },
            { label: "Lien", value: currencyFormat(employment?.original_lien) },
            { label: "Final Lien", value: currencyFormat(employment?.final_lien) },
            {
              label: "Date Verified",
              value: formatDateForPanelDisplay(employment?.date_verified),
            },
          ];

          const lienPaidDate = employment?.lien_paid_date;
          const lienPaidAmount = employment?.lien_paid_amount;

          const buttonText =
            lienPaidDate && lienPaidAmount
              ? `Lien Paid • ${formatDateForPanelDisplay(lienPaidDate)} • ${currencyFormat(lienPaidAmount)}`
              : lienPaidDate
                ? `Lien Paid Date • ${formatDateForPanelDisplay(lienPaidDate)}`
                : lienPaidAmount
                  ? `Lien Paid Amount • ${currencyFormat(lienPaidAmount)}`
                  : "Lien Not Paid";
          return (
            <div key={id} className="expert record-panel">
              <PanelActionBarComponent
                compact
                id={id}
                page_id={12}
                panelIconSrc={"/BP_resources/images/icon/defendants-icon-color.svg"}
                title={employer_name}
                name={employment_contact?.name}
                type="Wage Loss"
              />

              <div className="d-flex flex-wrap record-panel-body" style={{ gap: "5px" }}>
                <div className="leins-container-six">
                  <div className="min-w-260px-client">
                    {/*  */}
                    <ContactPanelForTreatment
                      id={id}
                      name={employment_contact?.name}
                      dynamic_label={"Employer Name"}
                      panel_name={"Employment"}
                      phone_number={employment_contact?.phone_number}
                      email={employment_contact?.email}
                      pageName={"Employment"}
                      websiteURL={employment_contact?.website}
                      className="m-b-0"
                      address1={employment_contact?.address1}
                      address2={employment_contact?.address2}
                      city={employment_contact?.city}
                      state={employment_contact?.state}
                      zip_code={employment_contact?.zip}
                      buttonData={DefendantButtonsConfig}
                      fax_number={employment_contact?.fax}
                      // genrate_doc_address={"Employment Address"}
                      genrate_doc_address={0}
                      templateDropdownId={0}
                      templatePageId={12}
                      onSelectObject={() => {
                        onEdit(employment, "employment");
                      }}
                    />
                  </div>

                  <div className="min-w-260px-client">
                    {/*  */}
                    <ContactPanelForTreatment
                      id={id}
                      name={
                        supervisor?.first_name || supervisor?.last_name
                          ? `${supervisor?.first_name || ""} ${supervisor?.last_name || ""}`.trim() ||
                            undefined
                          : undefined
                      }
                      dynamic_label={
                        supervisor?.defendantType_name !== "Private Individual Defendant"
                          ? "Full Name"
                          : ""
                      }
                      panel_name={"Supervisor"}
                      phone_number={supervisor?.phone_number}
                      email={supervisor?.email}
                      address1={supervisor?.address1}
                      address2={supervisor?.address2}
                      city={supervisor?.city}
                      state={supervisor?.state}
                      zip_code={supervisor?.zip}
                      buttonData={DefendantButtonsConfig}
                      // genrate_doc_address={""}
                      onSelectObject={() => onEdit(employment, "supervisor")}
                      pageName={"Employment"}
                      websiteURL={supervisor?.website}
                      fax_number={supervisor?.fax}
                      genrate_doc_address={0}
                      templateDropdownId={0}
                      templatePageId={12}
                    />
                  </div>

                  <div className="min-w-260px-client">
                    {/*  */}
                    <ContactPanelForTreatment
                      id={id}
                      name={
                        manager?.first_name || manager?.last_name
                          ? `${manager?.first_name || ""} ${manager?.last_name || ""}`.trim() ||
                            undefined
                          : undefined
                      }
                      dynamic_label="Full Name"
                      panel_name={"Manager"}
                      phone_number={manager?.phone_number}
                      email={manager?.email}
                      address1={manager?.address1}
                      address2={manager?.address2}
                      city={manager?.city}
                      state={manager?.state}
                      zip_code={manager?.zip}
                      buttonData={DefendantButtonsConfig}
                      genrate_doc_address={0}
                      templateDropdownId={0}
                      templatePageId={12}
                      onSelectObject={() => onEdit(employment, "manager")}
                      pageName={"Employment"}
                      websiteURL={manager?.website}
                      fax_number={manager?.fax}
                    />
                  </div>

                  <div className="min-w-260px-client">
                    <InfoPanelWithoutKeyValue
                      panel_name={"Losses"}
                      data={employmentTimeInfoData}
                      onSelectReport={() => onEdit(employment, "employeeBottom")}
                      defaultLength={5}
                      panelClassName="min-height-auto pe-0 panel-widths"
                      hasBtn={true}
                      buttonText={`Total Lost Wages: ${currencyFormat(employment?.total_wage_lost)}`}
                      colorGiven={"var(--primary-25)"}
                    />
                  </div>
                  <div className="min-w-260px-client">
                    {/*  */}
                    <ContactPanelForTreatment
                      id={id}
                      name={employment?.disability_lien_contact?.name}
                      dynamic_label={"Agency Name"}
                      panel_name={"Disability Agency"}
                      phone_number={employment?.disability_lien_contact?.phone_number}
                      email={employment?.disability_lien_contact?.email}
                      address1={employment?.disability_lien_contact?.address1}
                      address2={employment?.disability_lien_contact?.address2}
                      city={employment?.disability_lien_contact?.city}
                      state={employment?.disability_lien_contact?.state}
                      zip_code={employment?.disability_lien_contact?.zip}
                      ext={employment?.disability_lien_contact?.phone_ext}
                      buttonData={DefendantButtonsConfig}
                      genrate_doc_address={0}
                      templateDropdownId={0}
                      templatePageId={12}
                      onSelectObject={() => onEdit(employment, "disable")}
                      pageName={"Employment"}
                      websiteURL={employment?.disability_lien_contact?.website}
                    />
                  </div>

                  <div className="min-w-260px-client">
                    <InfoPanelWithoutKeyValue
                      panel_name={"Disability Lien"}
                      data={employmentInfoData}
                      onSelectReport={() => onEdit(employment, "disable")}
                      defaultLength={5}
                      panelClassName="min-height-auto pe-0 panel-widths"
                      hasBtn={true}
                      buttonText={buttonText}
                      colorGiven={"var(--primary-25)"}
                    />
                  </div>
                </div>
                <div
                  className=""
                  style={{
                    flex: 1,
                    minHeight: "155px",
                    paddingRight: "0px",
                    scrollbarWidth: "none",
                    minWidth: "min(330px, 100%)",
                  }}
                >
                  <p className="menu-bar-style columnsTitle text-center">Notes</p>

                  <TreatmentNotesSection
                    entity_type={"Employment"}
                    record_id={id}
                    module={"Employments"}
                  />
                </div>
              </div>

              <div className=" documents-wrapper m-t-5">
                <div className="col-12">
                  {/* <div className="height-25">
                    <h4 className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case background-main-10 font-weight-semibold text-center client-contact-title">
                      Employment {employer_name} Quick-Access Document Row
                    </h4>
                  </div> */}
                  <DocumentRow
                    pageName={`Employment ${employer_name || ""} Quick-Access`}
                    clientProvider={employment}
                    page_id={12}
                    showSaveToPage={false}
                  />
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <>
          {/* <div className="w-100 d-flex justify-content-center">
            <div
              className="placeholder-panel px-5 py-1"
              style={{ width: "372px" }}
              onClick={() => setShow(true)}
            >
              <span className="text-center text-uppercase font-weight-semibold">
                No Client Employment added
              </span>
              <span className="text-center text-uppercase font-weight-semibold">Click to Add.</span>
            </div>
          </div> */}
        </>
      )}
      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="Employment"
          dropdownName={dropdownName}
          instanceId={instanceIdForGenrateDoc}
        />
      )}
    </>
  );
};

export default WageLossTab;
